import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=adbabc4a&scoped=true"
import script from "./Deal.vue?vue&type=script&lang=js"
export * from "./Deal.vue?vue&type=script&lang=js"
import style0 from "./Deal.vue?vue&type=style&index=0&id=adbabc4a&prod&scoped=true&lang=css"
import style1 from "./Deal.vue?vue&type=style&index=1&id=adbabc4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbabc4a",
  null
  
)

export default component.exports